import FqApi from '@/services/fq-api'
import ProtoBuf from 'protobufjs'
const baseUrl = '/systemmessage'

export default {
  async getMessages(filter) {
    const serialised = this.serialiseMessageFilter(filter)
    const url = `${baseUrl}/list?filter=${serialised}`
    const result = await FqApi.get(url)
    return result.data
  },
  serialiseMessageFilter(filter) {
    const entityProto = require('../../../assets/proto/systemmessage/SystemMessageFilter.proto')
    const filterMessage = entityProto.SystemMessageFilter.SystemMessageFilterModel
    const buffer = filterMessage.encode(filter).finish()
    const b64encoded = ProtoBuf.util.base64.encode(buffer, 0, buffer.length)
    return encodeURIComponent(b64encoded)
  },
  async getNewEntity() {
    const result = await FqApi.get(`${baseUrl}/new`)
    return result.data
  },
  async getEntity(id) {
    const rs = await FqApi.get(`${baseUrl}/${id}`)
    const data = rs.data
    return data
  },
  async postEntity(entity) {
    return FqApi.post(baseUrl, entity)
  },
  async putEntity(entity) {
    return FqApi.put(`${baseUrl}/${entity.systemMessageId}`, entity)
  },
  async getMessage(id) {
    const url = `${baseUrl}/${id}`
    const result = await FqApi.get(url)
    return result.data
  },
  async createMessage(message) {
    const url = `${baseUrl}`
    const result = await FqApi.post(url, message)
    return result.data
  },
  async updateMessage(id, message) {
    const url = `${baseUrl}/${id}`
    const result = await FqApi.put(url, message)
    return result.data
  },
  async deleteMessage(id) {
    const url = `${baseUrl}/${id}`
    const result = await FqApi.delete(url)
    return result.data
  },
  async getMessagesInRange() {
    const url = `${baseUrl}/list/inrange`
    const result = await FqApi.get(url)
    return result.data
  }
}

